module.exports = __webpack_public_path__ + "img/banner6.9d7f56ca.jpg";